import { render, staticRenderFns } from "./financeTable.vue?vue&type=template&id=2c86516a&scoped=true&"
import script from "./financeTable.vue?vue&type=script&lang=js&"
export * from "./financeTable.vue?vue&type=script&lang=js&"
import style0 from "./financeTable.vue?vue&type=style&index=0&id=2c86516a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86516a",
  null
  
)

export default component.exports